import { Link } from "@mui/material";
import styled from "@emotion/styled";

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`;

export const SvgContainer = styled.div`
  margin-top: 20px;
  width: 100%;
`;

export const StyledLink = styled(Link)(() => {
  return {
    textDecoration: "none",
  };
});
